<template>
  <section>
    <loading-flux :value="loading"></loading-flux>
    <v-dialog
      v-model="modalAction"
      max-width="1000px"
      scrollable
      @keydown="executeCloseUpdateAdministrativeApproval"
      @click:outside="executeCloseUpdateAdministrativeApproval"
    >
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>
            Actualizar Aprobación Administrativa del Cargo:
            <b>
              {{
                currentAdministrativeApproval
                  ? ` ${currentAdministrativeApproval.charge}`
                  : " Cargando..."
              }}
            </b>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-form
            @submit.prevent="changeUserAdministrativeApproval"
            class="my-5"
          >
            <v-row align-content="center" justify="center">
              <v-col
                cols="12"
                md="6"
                sm="12"
                v-if="
                  currentAdministrativeApproval &&
                    currentAdministrativeApproval.charge !== CHARGE_BUYER
                "
              >
                <v-autocomplete
                  :items="wrappedEmployees"
                  v-model="$v.form.email.$model"
                  item-text="label"
                  item-value="email"
                  @update:search-input="
                    $event !== null ? getEmployeesData($event) : null
                  "
                  :loading="loadingEmployees"
                  :error="$v.form.email.$invalid && submitUpload"
                  :error-messages="
                    $v.form.email.$invalid && submitUpload
                      ? 'Este campo es requerido'
                      : null
                  "
                  searchable
                  label="Empleado"
                  placeholder="Selecciona un empleado"
                  hide-details
                ></v-autocomplete>
              </v-col>
              <v-col v-else cols="12" md="6" sm="12">
                <h5 class="text-center mt-6">
                  CECO AB-CPRA
                </h5>
              </v-col>
              <v-col
                cols="12"
                md="6"
                sm="12"
                v-if="
                  currentAdministrativeApproval &&
                    currentAdministrativeApproval.charge !==
                      CHARGE_ADMINISTRATIVE_OPERATIONS_MANAGER
                "
              >
                <v-text-field
                  type="number"
                  :min="1"
                  v-model="$v.form.max_amount.$model"
                  :error="$v.form.max_amount.$invalid && submitUpload"
                  :error-messages="
                    $v.form.max_amount.$invalid && submitUpload
                      ? 'Este campo es requerido'
                      : null
                  "
                  hide-details
                  label="Ingresa el monto máximo"
                ></v-text-field>
              </v-col>
              <v-col v-else cols="12" md="6" sm="12">
                <h5 class="text-center mt-6">
                  Infinito
                </h5>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            class="text-white"
            @click="changeUserAdministrativeApproval"
          >
            <small>
              Actualizar
            </small>
          </v-btn>
          <v-btn
            color="red darken-1"
            outlined
            @click="executeCloseUpdateAdministrativeApproval"
          >
            <small>
              Cerrar
            </small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import config from "@/config";
import { mapActions, mapGetters } from "vuex";
import {
  CHARGE_ADMINISTRATIVE_OPERATIONS_MANAGER,
  CHARGE_BUYER,
} from "@/constants/maintainers";
import swal from "sweetalert2";
export default {
  props: {
    modalAction: {
      type: Boolean,
      required: true,
    },
    closeModalUpdateAdministrativeApproval: {
      type: Function,
      default: () => {},
    },
    currentAdministrativeApproval: {
      default: null,
    },
  },
  data() {
    return {
      CHARGE_ADMINISTRATIVE_OPERATIONS_MANAGER,
      CHARGE_BUYER,
      loading: false,
      loadingEmployees: false,
      submitUpload: false,
      debounce: null,
      debounceTime: 500,
      form: {
        email: null,
        max_amount: null,
      },
    };
  },
  validations() {
    return {
      form: {
        email:
          this.currentAdministrativeApproval &&
          this.currentAdministrativeApproval.charge !== CHARGE_BUYER
            ? { required: true }
            : {},
        max_amount:
          this.currentAdministrativeApproval &&
          this.currentAdministrativeApproval.charge !==
            CHARGE_ADMINISTRATIVE_OPERATIONS_MANAGER
            ? { required: true }
            : {},
      },
    };
  },
  methods: {
    ...mapActions({
      sendUpdateAdministrativeApprovalAmount:
        "maintainers/updateAdministrativeApprovalAmount",
      sendUpdateAdministrativeApprovalEmail:
        "maintainers/updateAdministrativeApprovalEmail",
      getSubstituteEmployees: "maintainers/getSubstituteEmployees",
    }),
    async getEmployeesData(search = "") {
      if (search === null || !search.includes("(")) {
        clearTimeout(this.debounce);
        let self = this;
        this.debounce = await setTimeout(async function() {
          self.loadingEmployees = true;
          await self.getSubstituteEmployees({
            password: config.password_manteiners,
            page: 0,
            filter: search ?? undefined,
          });
          self.loadingEmployees = false;
        }, self.debounceTime);
      }
    },
    executeCloseUpdateAdministrativeApproval($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.resetForm();
        this.closeModalUpdateAdministrativeApproval($event);
      }
    },
    resetForm() {
      this.submitUpload = false;
      this.form.max_amount = null;
      this.form.email = null;
    },
    async changeUserAdministrativeApproval() {
      let resp = null;
      this.submitUpload = true;
      let self = this;
      if (!this.$v.form.$invalid) {
        this.loading = true;
        let payloadAmount = {
          index: this.currentAdministrativeApproval.sale_order_index,
          amount: this.form.max_amount,
        };

        let payloadEmail = {
          index: this.currentAdministrativeApproval.sale_order_index,
          email: this.form.email,
          ignore: true,
        };

        if (
          this.currentAdministrativeApproval.charge !==
          CHARGE_ADMINISTRATIVE_OPERATIONS_MANAGER
        ) {
          resp = await this.sendUpdateAdministrativeApprovalAmount(
            payloadAmount
          );
        }

        if (this.currentAdministrativeApproval.charge !== CHARGE_BUYER) {
          resp = await this.sendUpdateAdministrativeApprovalEmail(payloadEmail);
        }

        if (!resp || !resp.status || resp.status == 500) {
          swal.fire({
            icon: "error",
            title: "Error",
            text: "Ha ocurrido un error en el servidor, intenta nuevamente",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 3000,
            timerProgressBar: true,
          });
        }
        if (resp.status == 400) {
          swal.fire({
            icon: "error",
            title: "Error",
            text: resp.data.detail,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 3000,
            timerProgressBar: true,
          });
        }
        if (resp.status == 200) {
          swal.fire({
            icon: "success",
            title: "Excelente",
            text: `Aprobación Administrativa actualizada con éxito`,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 6000,
            timerProgressBar: true,
          });
          this.resetForm();
          this.$emit("administrativeApprovalUpdated");
          this.closeModalUpdateAdministrativeApproval(true);
        }
        this.loading = false;
      }
    },
    setCurrentAdministrativeApproval(administrativeApproval) {
      this.form.max_amount = administrativeApproval.amount;
      this.getEmployeesData(
        administrativeApproval ? administrativeApproval.email : null
      );
      this.form.email = administrativeApproval
        ? administrativeApproval.email
        : null;
    },
  },
  computed: {
    ...mapGetters({
      substituteEmployees: "maintainers/substituteEmployees",
    }),
    wrappedEmployees() {
      return this.substituteEmployees.employees.map((item) => {
        return {
          label: `${item.full_name} (${item.email})`,
          ...item,
        };
      });
    },
  },
  watch: {
    currentAdministrativeApproval: {
      handler(newAdministrativeApproval) {
        if (newAdministrativeApproval) {
          this.setCurrentAdministrativeApproval(newAdministrativeApproval);
        } else {
          this.resetForm();
        }
      },
    },
  },
};
</script>

<style></style>
